import React from 'react';
import proptypes from 'prop-types';
import styles from './postboost.module.scss';

const NumberCircle = ({ number }) => {
  return (
    <div className={styles.numberCircle}>
      <span className={styles.marginAuto}>{number}</span>
    </div>
  );
};

NumberCircle.propTypes = {
  number: proptypes.number,
};

export default NumberCircle;
